export function SpotlightBadge() {
	return (
		<span className="inline-flex items-center gap-1 font-semibold text-app-yellow text-xs">
			<span>&#9733;</span>
			Spotlight
		</span>
	)
}
